module.exports = __webpack_public_path__ + "img/404.a4ed1409.jpg";